var map = {
	"./affirm.svg": 26153,
	"./algolia.svg": 14068,
	"./amazon.svg": 58069,
	"./avatax.svg": 38340,
	"./contentful.svg": 83110,
	"./gladly.svg": 43333,
	"./hubspot.svg": 28486,
	"./klarna.svg": 88603,
	"./klaviyo.svg": 29113,
	"./mailchimp.svg": 21976,
	"./omnisend.svg": 554,
	"./orderdesk.svg": 38756,
	"./paypal.svg": 39215,
	"./paysafecard.svg": 94,
	"./plytix.svg": 62403,
	"./quickbooks.svg": 58541,
	"./rally.svg": 22219,
	"./resolve.svg": 45408,
	"./segment.svg": 47921,
	"./sendgrid.svg": 22048,
	"./shipstation.svg": 7053,
	"./slack.svg": 78381,
	"./smartystreets.svg": 68465,
	"./square.svg": 56086,
	"./taxjar.svg": 11818,
	"./yotpo.svg": 86933,
	"./zapier.svg": 46141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82960;